import axios from "axios";

export default function WorktypeEmployeeRemoveService(formData, worktypeId) {
  return axios({
    method: 'DELETE',
    url: process.env.REACT_APP_API_HOST + "/worktype/" + worktypeId + "/employees",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
